import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { NotFound } from 'containers/NotFound';
import OrderEditing from './index';
import SettingsViewWrapper from 'components/SettingsWrapperView';
import {
  OrderEditingPage,
  orderEditingPages,
  orderEditingPath,
} from './OrderEditingSettingsTabs';

const legacySections: Record<string, OrderEditingPage> = {
  '#order-edit-setup': 'rules',
  '#order-edit-policy': 'rules',
  '#order-edit-expanded': 'rules',
  '#order-edit-support': 'rules',
  '#order-edit-appearance': 'customization',
  '#order-edit-requests': 'requests',
  '#order-edit-integrations': 'integrations',
  '#order-edit-usage': 'activity',
};

const legacyPages: Array<[string, OrderEditingPage]> = [
  ['setup', 'rules'],
  ['support', 'rules'],
  ['requests', 'requests'],
  ['activity', 'activity'],
];

const settingsRoutes = orderEditingPages.filter(
  (page) => page.id !== 'requests' && page.id !== 'activity',
);

export const OrderSettings = () => {
  const { pathname, search, hash } = useLocation();
  const activePage = settingsRoutes.find((page) =>
    pathname.replace(/\/$/, '').endsWith(`/${page.id}`),
  )?.id;
  const redirect = (page: OrderEditingPage) => (
    <Navigate
      to={{
        pathname: orderEditingPath(page),
        search,
        hash,
      }}
      replace
    />
  );

  return (
    <SettingsViewWrapper
      activeNav={`order-settings/${activePage || 'customization'}`}
      sectionId="order-edit"
    >
      <Routes>
        <Route
          index
          element={redirect(legacySections[hash] || 'customization')}
        />
        <Route
          path="/all"
          element={redirect(legacySections[hash] || 'customization')}
        />
        {legacyPages.map(([path, page]) => (
          <Route key={path} path={`/${path}`} element={redirect(page)} />
        ))}
        {settingsRoutes.map((page) => (
          <Route
            key={page.id}
            path={`/${page.id}`}
            element={<OrderEditing key={page.id} page={page.id} />}
          />
        ))}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </SettingsViewWrapper>
  );
};
